<div class="ms-3 badge-gifts-description d-flex flex-column justify-content-center">
  <ng-content></ng-content>
  <a href="{{'SHARED.LINKS.GIFT-AD.LINK' | translate }}"
     target="_blank"
     class="d-inline-flex align-items-center">
    {{ 'SHARED.BADGE-GIFTS.LINK-MORE-INFO' | translate }}
    <i-feather name="external-link"
               class="sm ms-1"></i-feather>
  </a>
</div>
